"use strict";

var _taggedTemplateLiteral = require("/app/react/marvin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _objectSpread = require("/app/react/marvin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");

var _objectWithoutProperties = require("/app/react/marvin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var _chunkDRITYWJDjs = require('./chunk-DRITYWJD.js');

var _chunkNESC3UD7js = require('./chunk-NESC3UD7.js');

var _styledcomponents = require('styled-components');

var _styledcomponents2 = _interopRequireDefault(_styledcomponents);

var _jsxruntime = require('react/jsx-runtime');

var m = function m(_ref) {
  var _ref$color = _ref.color,
      n = _ref$color === void 0 ? "inverse" : _ref$color,
      o = _ref.small,
      l = _objectWithoutProperties(_ref, ["color", "small"]);

  return _jsxruntime.jsx.call(void 0, d, _objectSpread({
    $small: o,
    "data-testid": "loading-spinner-animation"
  }, l, {
    children: _jsxruntime.jsx.call(void 0, o ? S : f, {
      color: n
    })
  }));
};

m.defaultTestId = "loading-spinner-animation";

var s = _styledcomponents.keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    0% {\n        transform: rotate(0deg)\n    }\n    to {\n        transform: rotate(1turn)\n    }\n"]))),
    d = exports.b = _styledcomponents2.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    ", ";\n    height: ", "px;\n    width: ", "px;\n    position: relative;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n"])), _chunkNESC3UD7js.e, function (_ref2) {
  var n = _ref2.$small;
  return n ? 14 : 20;
}, function (_ref3) {
  var n = _ref3.$small;
  return n ? 14 : 20;
}),
    f = exports.c = _styledcomponents2.default.call(void 0, _chunkDRITYWJDjs.b)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    animation: ", " 1s infinite linear;\n"])), s),
    S = exports.d = _styledcomponents2.default.call(void 0, _chunkDRITYWJDjs.a)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    animation: ", " 1s infinite linear;\n"])), s);

exports.a = m;
exports.b = d;
exports.c = f;
exports.d = S;